import React from "react";

import { Icon } from "@tvg/design-system";
import PromosIconContainer from "./styled-components";

const renderIcon = (name) => {
  return (
    <Icon
      name={name}
      size="s"
      lineColor="content.mtp"
      shouldUseColorTokens
      overrideSize={parseFloat(getComputedStyle(document.body).fontSize) * 3}
      style={{ zIndex: 1 }}
    />
  );
};

const PromosIcon = (props) => (
  <PromosIconContainer data-qa-label={props.qaLabel}>
    {renderIcon(props.icon)}
  </PromosIconContainer>
);

PromosIcon.defaultProps = {
  qaLabel: "promosIcon"
};

export default PromosIcon;
